var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartPanel"},[_c('div',{ref:"charts",attrs:{"id":"charts"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }